import { useQueryClient } from '@tanstack/react-query'
import { DependencyStatus } from '@solum/ui'
import { degradationMessage, health } from '../data/dependencyHealth'

/** Bind the Console query cache and transport-owned store to the shared region. */
export function DependencyDegradation() {
  const queryClient = useQueryClient()
  return (
    <DependencyStatus source={health} messageFor={degradationMessage}
      onRetry={() => { void queryClient.refetchQueries({ type: 'active' }) }} />
  )
}
